import { DisputeChargebackStatus } from "./enum/dispute-chargeback-status";

export class DisputeChargebackLog {
  requestId: string = "";
  accountName: string = "";
  chargebackId: string = "";
  status?: DisputeChargebackStatus;
  date: string = "";
  message?: string = undefined;
}

